import React, { FC } from 'react'

//* styles
import {
  FormFlexBodyContainer,
  FormFlexContainer,
  FormFlexContentContainer,
  FormFlexFormContainer,
  FormFlexFormIntro,
  FormFlexHeroContainer,
} from './style'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'
import { renderMarketoOrIframe } from '../../../utils/cn.utils'
import { internalLinkHandler } from '../../../utils/link.utils'

//* components
import Button from '../../global/button'
import ContentBlock from '../../global/contentBlock'
import GlobalContainer from '../../global/globalContainer'
import Hero from '../../global/hero'
import Marketo from '../../global/marketo'
import RawHTML from '../../global/rawHTML'
import SEOTags from '../../global/seoTags'
import Typography from '../../global/typography'

type Props = {
  data: any
  path: string
  availableLocales: any
  defaultLocale: string
}

export const Modules: FC<Props> = ({ data, path, availableLocales, defaultLocale }) => {
  let rawHTMLData = null

  const dynamicPageContent = data.flexSection?.map((module: any, i: Number) => {
    switch (module.__typename) {
      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.TOPIC_CTA:
        const buttonHref = module.internalLink
          ? internalLinkHandler(module.internalLink)
          : module.externalUrl

        return (
          <Button
            key={`page-component--${i}`}
            icon={true}
            href={buttonHref}
            text={module.text || ''}
            type="text-link"
            size={'small'}
            theme={'light'}
            useCase={'formFlex'}
          />
        )

      case ModuleNames.RAW_HTML:
        rawHTMLData = module
        break
    }
  })
  const cnLocale = LocaleCodes.CHINESE.code
  return (
    <div data-cy={`FlexFormPage`}>
      <SEOTags
        seoMetadata={data.seoMetadata}
        slug={data.slug || ''}
        path={path}
        locale={data.defaultLocale}
        siteSection="Form Flex"
        availableLocales={availableLocales}
      />

      <FormFlexHeroContainer>
        {data.hero && (
          <Hero
            data={data.hero}
            pageType="formFlex"
            locale={defaultLocale}
            showBreadcrumbs={!!data.breadcrumb}
            breadcrumb={data.breadcrumb}
            pageTitle={data.pageName}
          />
        )}
      </FormFlexHeroContainer>

      <FormFlexContainer>
        <GlobalContainer className="formFlex--globalContainer">
          <FormFlexBodyContainer className="formFlex--bodyContainer">
            <FormFlexFormContainer className="formFlex--formContainer">
              {data.formIntro && (
                <FormFlexFormIntro>
                  <Typography type="header5" className="formFlex--FormIntro">
                    {data.formIntro}
                  </Typography>
                </FormFlexFormIntro>
              )}
              {defaultLocale !== cnLocale ? (
                <>
                  {data.formType === 'Marketo form' && data.marketoForm?.marketoForm && (
                    <Marketo formData={data.marketoForm.marketoForm} />
                  )}

                  {(data.formType === 'Marketo form' || data.formType === 'iFrame') && (
                    <RawHTML data={rawHTMLData} />
                  )}

                  {data.formType === 'iFrame' && data.iFrameLink && (
                    <iframe width="100%" height="750" src={data.iFrameLink} id="iFrame-flexForm" />
                  )}
                </>
              ) : (
                <>
                  {data.cnFormOverride &&
                    renderMarketoOrIframe({
                      defaultLocale: defaultLocale,
                      marketoFormData: Marketo,
                      cnFormOverride: data.cnFormOverride,
                    })}
                </>
              )}
            </FormFlexFormContainer>

            <FormFlexContentContainer className="formFlex--contentContainer">
              {dynamicPageContent}
            </FormFlexContentContainer>
          </FormFlexBodyContainer>
        </GlobalContainer>
      </FormFlexContainer>
    </div>
  )
}
